import React from 'react';
import { connect } from 'react-redux';

import ScrollablePanel from '../commons/components/scroll/ScrollablePanel.jsx';
import SearchResultsHeader from './SearchResultsHeader.jsx';
import DocumentsTables from '../commons/components/document/table/DocumentsTables';

function normalize(text) {
  return (text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
}

const SearchPage = ({ documents, search: { text, loading, historyDocuments }, offline }) => {
  const normalizedFilter = normalize(text);
  const filteredDocuments = documents.filter(doc =>
    normalize(doc.title).includes(normalizedFilter) ||
    (doc.attachments || []).some(att => normalize(att.title).includes(normalizedFilter)));
  let historyMessage = 'Aucun sujet ne correspond à votre recherche.';
  if (offline) {
    historyMessage = 'La recherche dans les archives n’a pas pu être faite car vous n\'êtes pas connecté à internet.';
  } else if (loading) {
    historyMessage = 'Recherche en cours...';
  }

  return (
    <ScrollablePanel className="main-content-without-top">
      <SearchResultsHeader/>
      <div className="main-content-table">
        <DocumentsTables
          title="Sujets publiés"
          documents={filteredDocuments}
          emptyMessage="Aucun sujet ne correspond à votre recherche."
        />
        <DocumentsTables
          title="Archives"
          documents={historyDocuments}
          emptyMessage={historyMessage}
        />
      </div>
    </ScrollablePanel>
  );
};

export default connect(state => ({
  documents: state.documents.data,
  search: state.search,
  offline: state.appState.offline,
}))(SearchPage);



// WEBPACK FOOTER //
// ./book/src/search/SearchPage.jsx